import * as React from 'react';
import FailureScreen from 'src/frontend-common/components/FailureScreen';
import LoadingScreen from 'src/frontend-common/components/LoadingScreen';

import { CompleteUserForm } from './components/CompleteUserForm';
import { useGetCurrentUserQuery } from 'src/redux/services/users';
import { styled } from '@mui/material';
import Layout from '../Login/Layout';

const CustomLoadingScreen = styled(LoadingScreen)(({ theme }) => ({
  minHeight: '500px',
  backgroundColor: theme.palette.background.paper,
}));

export const UserCompletePage: React.FC = () => {
  const { data, isFetching, isError } = useGetCurrentUserQuery();

  return (
    <>
      {isError && <FailureScreen>there was an error when fetching the user data! Please try refreshing the page.</FailureScreen>}

      {isFetching && <CustomLoadingScreen variant="circle" />}

      {!isFetching && data && (
        <Layout>
          <CompleteUserForm userData={data.item} />
        </Layout>
      )}
    </>
  );
};
